import React from "react";
import { Helmet } from "react-helmet";

// DynamicTitleComponent updates the document title dynamically
const DynamicTitleComponent = ({ title }) => (
  <Helmet>
    {/* Set the document title; if no title is provided, use "Default Title" */}
    <title>{title || "Default Title"}</title>
  </Helmet>
);

export default DynamicTitleComponent;